import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { connect } from 'react-redux';
import { compose } from 'recompose'

const styles = {
  subNav: {
    marginBottom: '1em'
  }
  
}

class SubNav extends Component {
 


  render () {
    const { classes, navState } = this.props
    return (
      <div style={styles.subNav}>
        {navState
          ? <Button onClick={()=>this.props.onClickAddEvent(null)} variant="contained" className={classes.button} color="secondary" >
              Schließen
            </Button>
          :  <Button onClick={()=>this.props.onClickAddEvent(1)} variant="contained" className={classes.button} color="primary" >
              Neuen Hilfebedarf erstellen
            </Button>
        
        }
         
      
      </div>
    )
  }
}

const mapDispatchToProps = (dispatch) => ({
  onClickAddEvent: (value) => dispatch({ type: 'TOGGLE_ADDEVENT', value })
})

const mapStateToProps = (state) => ({
  navState: state.appState.addEventState,
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles)

)(SubNav)


// WEBPACK FOOTER //
// ./src/Components/SubNav/SubNav.js